const { DeviceId } = ( window as any ).Capacitor?.Plugins ?? {};
const is_native = !!DeviceId;

export const DeviceIdPlugin = {
  isAvailable(): boolean
  {
    return is_native;
  },

  // Returns the hardware-stable Android ID on native Android builds, or null
  // on web / Telegram / iOS where the native plugin isn't present.
  async getAndroidId(): Promise<string | null>
  {
    if ( !is_native ) return null;
    try
    {
      const { androidId } = await DeviceId.getAndroidId();
      return androidId ?? null;
    }
    catch
    {
      return null;
    }
  },
};
